import TeacherStudentsData from './TeacherStudentsData';

export default TeacherStudentsData;
